import { ArmyBook } from '@Models';
import {
  ArmyBookRepository,
  RequestArmyBookSuccess,
} from '@Repository/publication';
import { inject, injectable } from 'inversify';
import { TYPES } from '@Types';
import { RequestAction } from '@Repository/RequestAction';
import { Result } from '@Redux/type';
import { IEditableEntityAction } from '@Redux/IEditableEntityAction';
import { PayloadAction } from '@reduxjs/toolkit';
import armyBookSlice from '@Redux/reducers/publication/army-book.slice';
import { DeleteRepository } from '@Repository/DeleteRepository';

@injectable()
export class ArmyBookAction extends IEditableEntityAction<
  string,
  ArmyBook,
  RequestArmyBookSuccess
> {
  @inject(TYPES.Repository.ArmyBookRepository)
  private _repository!: ArmyBookRepository;

  getDeleteRepository(): DeleteRepository<string> {
    return this._repository;
  }

  protected fetchDataSuccess(item: ArmyBook): PayloadAction<ArmyBook> {
    return armyBookSlice.actions.setMyArmyBook(item);
  }

  protected cacheDataSuccess(item: ArmyBook): PayloadAction<ArmyBook> {
    return armyBookSlice.actions.setMyArmyBook(item);
  }

  protected haveError(message: string): PayloadAction<string> {
    return armyBookSlice.actions.setError(message);
  }

  protected areLoading(bool: boolean): PayloadAction<boolean> {
    return armyBookSlice.actions.setLoading(bool);
  }

  protected async getCachedItem({
    entityId,
    locale,
  }: {
    entityId: string;
    locale: string | null;
  }): Promise<ArmyBook | null> {
    return await this._repository.getCached(entityId, {
      locale: locale ?? null,
    });
  }

  protected async getItem({
    entityId,
    locale,
  }: {
    entityId: string;
    locale: string | null;
  }): Promise<RequestAction> {
    return await this._repository.get(entityId);
  }

  protected subFetchDataBefore =
    ({ entity }: { entity: ArmyBook }): Result<void> =>
    (dispatch) => {};

  protected subFetchDataAfter =
    ({
      entity,
      cachedItem,
    }: {
      entity: ArmyBook;
      cachedItem: ArmyBook | null;
    }): Result<void> =>
    (dispatch) => {};
}
